<template>
  <div v-if="visible" class="app-loading-overlay">
    <div class="app-loading-container">
      <!-- Logo动画 -->
      <div class="app-loading-logo">
        <div class="logo-container">
          <div class="logo-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="logo-text">天远数据平台</div>
        </div>
      </div>

      <!-- 加载动画 -->
      <div class="loading-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>

      <!-- 加载文本 -->
      <div class="loading-text">
        <span v-if="message">{{ message }}</span>
        <span v-else>正在加载...</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineModel('visible', {
  type: Boolean,
  default: false
})
</script>

<style scoped>
.app-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(248, 250, 252, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.app-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.app-loading-logo {
  animation: logoFloat 2s ease-in-out infinite;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.logo-icon {
  width: 4rem;
  height: 4rem;
  color: #3b82f6;
  animation: logoPulse 2s ease-in-out infinite;
}

.logo-icon svg {
  width: 100%;
  height: 100%;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1e293b;
  letter-spacing: 0.2em;
}

.loading-spinner {
  position: relative;
  width: 3rem;
  height: 3rem;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
}

.spinner-ring:nth-child(1) {
  animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
  width: 80%;
  height: 80%;
  top: 10%;
  left: 10%;
  animation-delay: 0.2s;
  animation-duration: 1.4s;
}

.spinner-ring:nth-child(3) {
  width: 60%;
  height: 60%;
  top: 20%;
  left: 20%;
  animation-delay: 0.4s;
  animation-duration: 1.6s;
}

.loading-text {
  color: #64748b;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  animation: textFade 2s ease-in-out infinite;
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes logoPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes textFade {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* 性能优化：减少动画效果 */
@media (prefers-reduced-motion: reduce) {
  .app-loading-logo,
  .logo-icon,
  .spinner-ring,
  .loading-text {
    animation: none !important;
  }
}

/* 性能优化：低端设备简化 */
@media (max-width: 640px) {
  .logo-icon {
    width: 3rem;
    height: 3rem;
  }

  .logo-text {
    font-size: 1.25rem;
  }

  .loading-spinner {
    width: 2.5rem;
    height: 2.5rem;
  }

  .loading-text {
    font-size: 0.875rem;
  }
}
</style>
